export default {
  index: {
    text1: "เชิญชวน",
    text2: "สินทรัพย์",
    text3: "บิล",
    text4: "โซนพิเศษ",
    text5: "สัญญา 1 ดาว",
    text6: "สมัครสมาชิก",
    text7: "สัญญา 2 ดาว",
    text8: "คำอธิบาย",
    text9: "เข้าร่วมชุมชนของเรา",
    text10: "ผูกบัญชีผู้อ้างอิง",
    text11: "กรุณาใส่ที่อยู่ผู้อ้างอิง",
    text12: "ยืนยัน",
    text13: "พูล激励",
    text14: "ส่วนเหลือของรางวัล",
    text15: "รอเปิดใช้งาน",
	text16: "คู่ค้าที่ประสานงาน",
  },
  wallet: {
    text1: "มูลค่าทั้งหมดของสินทรัพย์",
    text2: "บิล",
    text3: "ยอดคงเหลือ",
    text4: "ถอนออก",
    text5: "สิทธิของรายการไวท์ลิสต์",
    text6: "สิทธิ IDO",
    text7: "สมัครสมาชิก",
 text8: "兑换",
 
 },
 dui :{
 	text1: "兑换白名单权益",
 
 },
  pawn: {
    text1: "รายได้จะถูกชำระในเวลา 18:18 ของวันถัดไป 70% ของรายได้รายวันจะถูกชำระเป็น USDT และ 30% เป็นเหรียญ UES ที่มีมูลค่าเท่าเทียมกัน มูลค่าตลาดของ UES คือ 3U",
    text2: "สมัครสมาชิก",
    text3: "枚",
    text4: "สัญญา 1 ดาว",
    text5: "รายได้รายวัน",
    text6: "สัญญา 2 ดาว",
    text7: "สัญญา 3 ดาว",
    text8: "สัญญา Plus"
  },
  zy: {
    text1: "กำลังได้รับรายได้",
    text2: "หมดอายุแล้ว",
    text3: "จำนวน",
    text5: "ได้รับแล้ว",
    text4: "วันที่สมัครสมาชิก"
  },
  team: {
    text1: "ระดับปัจจุบัน",
    text2: "การสมัครสมาชิกของฉัน",
    text3: "业績ของโซนย่อย",
    text4: "ผู้อ้างอิงของฉัน",
    text5: "การสมัครสมาชิกของผู้อ้างอิง",
    text6: "ทีมของฉัน",
    text7: "业績ทั้งหมด",
    text8: "业績ของโซนย่อย",
    text9: "จำนวนสมาชิกในทีม",
    text10: "การอ้างอิงของฉัน",
    text11: "จำนวนการสมัครสมาชิก",
    text12: "ลิงค์เชิญชวน"
  },
  withdrawal: {
    text1: "จำนวนการถอน",
    text2: "เข้าบัญชี",
    text3: "ค่าธรรมเนียม",
    text4: "ยอดคงเหลือในกระเป๋าเงิน",
    text5: "ถอนและแช่แข็ง",
    text6: "ยืนยัน",
    text7: "กรุณาใส่จำนวนที่ต้องการถอน"
  },
  record: {
    text1: "ประเภท",
    text2: "จำนวน",
    text3: "เวลา"
  },
  header: {
    text1: 'เพิ่มเติม',
    text2: "ลิงค์อ้างอิง",
    text3: "หน้าหลัก",
    text4: "กระเป๋าเงิน",
    text5: "สมัครสมาชิก",
    text6: "สัญญาของฉัน",
    text7: "ทีมของฉัน",
	text8: 'RLP白名单',
  },
  lan: {
    text1: 'ภาษาอังกฤษ',
    text2: 'จีนเรียบง่าย',
    text3: 'จีนแบบดั้งเดิม',
    text4: 'ภาษาไทย',
    text5: 'ภาษาเกาหลี',
    text6: 'ภาษาญี่ปุ่น',
    text7: 'ภาษาเวียดนาม'
  },
  tost: {
    text1: 'รอเปิดใช้งาน',
    text2: 'กรุณาใส่จำนวนเหรียญที่ต้องการถอน',
    text3: 'ยอดคงเหลือไม่เพียงพอ',
    text4: 'คัดลอกสำเร็จ',
	text5: 'ถ่ายโอนออกอย่างน้อย 50 USDT',
  },
  rlp: {
  	 text10: "สมัครซื้อ RLP",
  	    text1: "คิวต้า 100 ในรายการสีขาว สามารถสมัครซื้อ 0.1BNB",
  	    text2: "สมัครซื้อ",
  	    text4: "ราคาสมัครซื้อ",
  	    text3: "คิวต้า 100 / 0.1BNB",
  	    text5: "BNB",
  	    text6: "รายการสีขาวของฉัน",
  	    text7: "สมัครซื้อ"
  	
  },
}